import React from "react";
import Swal from "sweetalert2";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { PedidosApi } from "../../../hooks/pedidosApi";
import Modal from "../../Modal/Modal";
import Titulo from "../../Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo";
import Form from "../../Form";
import { Input } from "../../Input";
import { Button } from "../../Button";
import { ModalContainer } from "./styles";

type Cliente = Record<string, any>;

interface EditarDadosClienteProps {
  cliente: Cliente;
  id_pedido: string | number;
  onSaved: () => void | Promise<void>;
}

const campos = [
  { key: "nome", label: "Nome" },
  { key: "telefone", label: "Telefone" },
  { key: "email", label: "Email" },
  { key: "cpf", label: "CPF" },
  { key: "cnpj", label: "CNPJ" },
  { key: "razao_social", label: "Razão social" },
  { key: "inscricao_estadual", label: "Inscrição estadual" },
  { key: "cep", label: "CEP" },
  { key: "estado", label: "Estado (UF)" },
  { key: "cidade", label: "Cidade" },
  { key: "bairro", label: "Bairro" },
  { key: "endereco", label: "Endereço" },
  { key: "numero", label: "Número" },
  { key: "complemento", label: "Complemento" },
];

const EditarDadosCliente: React.FC<EditarDadosClienteProps> = ({
  cliente,
  id_pedido,
  onSaved,
}) => {
  const { theme } = useTheme();
  const pedidos = PedidosApi();
  const [modal, setModal] = React.useState(false);
  const [form, setForm] = React.useState<Cliente>({});
  const [, setFormValid] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const abrir = () => {
    setForm({ ...cliente });
    setModal(true);
  };

  const salvar = async () => {
    setLoading(true);
    try {
      await pedidos.atualizarDadosCliente(id_pedido, form);
      setModal(false);
      await onSaved();
      Swal.fire({
        icon: "success",
        title: "Dados atualizados!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erro ao atualizar dados!",
        showConfirmButton: false,
        timer: 1500,
      });
    }
    setLoading(false);
  };

  return (
    <>
      <Modal isOpen={modal} setModal={setModal} width={"98vw"} maxWidth="800px">
        <ModalContainer theme={theme}>
          <Titulo
            titulo="Editar dados do cliente"
            subtitulo=""
            justifyContent="center"
          />
          <Form id="formDadosCliente" onSubmit={salvar} setFormValid={setFormValid}>
            <div className="campos">
              {campos.map(({ key, label }) => (
                <Input
                  key={key}
                  type="text"
                  label={label}
                  placeholder={label}
                  value={form[key] ?? ""}
                  onChange={(v) => setForm((f) => ({ ...f, [key]: v }))}
                />
              ))}
            </div>
            <div className="botoes">
              <div className="cancelar" onClick={() => setModal(false)}>
                Cancelar
              </div>
              <Button title="Salvar" loading={loading} onClick={salvar} />
            </div>
          </Form>
        </ModalContainer>
      </Modal>
      <Button title="Editar dados do cliente" onClick={abrir} />
    </>
  );
};

export default EditarDadosCliente;
